import { render } from "./FileUploadPage.vue?vue&type=template&id=8b10d002&scoped=true"
import script from "./FileUploadPage.vue?vue&type=script&lang=js"
export * from "./FileUploadPage.vue?vue&type=script&lang=js"

import "./FileUploadPage.vue?vue&type=style&index=0&id=8b10d002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b10d002"]])

export default __exports__